import { render, staticRenderFns } from "./FormatterJson.vue?vue&type=template&id=0601e2bc&scoped=true"
import script from "./FormatterJson.vue?vue&type=script&lang=js"
export * from "./FormatterJson.vue?vue&type=script&lang=js"
import style0 from "./FormatterJson.vue?vue&type=style&index=0&id=0601e2bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0601e2bc",
  null
  
)

export default component.exports